import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import aiMusicGeneratorApi from 'services/api/aiMusicGenerator/aiMusicGeneratorApi';
import { type VegaBundle } from 'services/store/ai/types';
import {
  bundleSelectors,
  selectAreAllLoaded,
  selectBundleGenerating,
  selectBundlesLoading,
  selectEarliestBundleId,
} from 'services/store/bundles/selectors';

const useBundles = () => {
  const [fetchBundles] = aiMusicGeneratorApi.useLazyGetBundlesQuery();

  const bundles = useSelector(bundleSelectors.selectAll);

  const isLoading = useSelector(selectBundlesLoading);
  const isGenerating = useSelector(selectBundleGenerating);
  const areAllLoaded = useSelector(selectAreAllLoaded);

  const earliestBundleId = useSelector(selectEarliestBundleId);

  const load = useCallback(
    async (lastBundleId?: VegaBundle['id']) => {
      const response = fetchBundles(
        lastBundleId ? { lastBundleId } : {}
      ).unwrap();
      await response;
      return response;
    },
    [fetchBundles]
  );

  const loadMore = useCallback(() => {
    load(earliestBundleId);
  }, [load, earliestBundleId]);

  return {
    bundles,
    load,
    loadMore,
    isLoading,
    isGenerating,
    areAllLoaded,
  };
};

export default useBundles;
